<!-- ---TEMPLATE--- -->
<template> 
  <div class="web-parent">
    <el-row>
      <!-- the row, going to repeat -->
      <div class="rowSpan24" id="webTabFontSizeChange" v-loading.fullscreen.lock="fullscreenLoading">
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1">
            <div class="menuTitle" v-for="(set,index) in groups" v-bind:key="index">
              <div class="newsTitle" v-on:click="set.open = !set.open" v-if="getWebRegisterFlag">WEB({{getWebFirstTabCheckboxValue}}/{{getThemeWebCount}}件)</div>
              <div class="webNewsTitle"  v-on:click="set.open = !set.open" v-else>WEB(未登録)</div>
            </div>
          </el-menu-item>
          <el-menu-item index="2">
            <div class="menuLable" v-if="getSortWebDateText">
              <div class="selectList year-drop">年月日：{{getSelectedWebSortDate}}</div>
              <i class="el-icon-arrow-up year-arrow" v-if="getAscendingWebDateIcon"></i>
              <i class="el-icon-arrow-down year-arrow" v-if="getDecendingWebDateIcon"></i>
            </div>
            <div class="menuLable" v-if="getSortWebTitleText">
              <div class="selectList year-drop">見出し：{{getSelectedWebSortTitle}}</div>
              <i class="el-icon-arrow-up year-arrow" v-if="getAscendingWebTitleIcon"></i>
              <i class="el-icon-arrow-down year-arrow" v-if="getDecendingWebTitleIcon"></i>
            </div>
          </el-menu-item>
          <el-menu-item index="3">
            <div class="strip first-strip" v-if="getSortWebDateText == true || getSortWebTitleText == true"></div>
          </el-menu-item>
          <el-menu-item index="4" class="select_custom" v-if="all_articles_selectable_flag">
            <div class="menuLable">
              <el-checkbox class="checkList select_custom_box" v-model="getWebCheckboxSelect" @change="handleCheckAllChange">
                <div class="selectList select_custom_label">全て選択</div>
              </el-checkbox>
            </div>
          </el-menu-item>
          <el-menu-item index="5">
            <div class="strip" v-if="all_articles_selectable_flag"></div>
            <div style="width: 6px;" v-else></div>
          </el-menu-item>
          <el-menu-item index="6">
            <div class="sortIcon">
              <el-popover placement="bottom-start" width="200" trigger="click" v-model="visible" class="bigPopUp">
                <div class="menuLable" slot="reference">
                  <div class="iconSVG ico_sort_up" tabindex="0"></div>
                  <div class="IconSort">ソート</div>   
                </div> 
                <template>
                  <el-form class="selectForm">
                    <el-form-item label="年月日" class="dateSelectLable">
                      <template>
                      <el-select v-model="getWebDateValue" class="dateSelect" @change="selectDateValue($event)">
                        <div class="drop1">
                        <el-option
                          class="dateOption"
                          v-for="item in dropdownoptions4"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option> 
                        </div>
                      </el-select>
                      </template>
                    </el-form-item>
                    <el-form-item label="見出し" class="headingLable">
                      <el-select v-model="getWebTitleValue" class="heading" @change="selectTitleValue($event)">
                        <div class="drop2">
                        <el-option
                        class="headingOption"
                          v-for="item in dropdownoptions3"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                        </div>
                      </el-select>
                    </el-form-item> 
                    <el-row type="flex" justify="space-between">
                      <el-button round class="roundGray" tabindex="1" @click="clear">リセット</el-button>
                      <el-row>
                        <el-button round class="roundGrayDark" tabindex="1" @click="cancelSort">キャンセル</el-button>
                        <el-button round class="roundBlue" tabindex="1" @click="articleSorting">OK</el-button>
                      </el-row>
                    </el-row>
                  </el-form>
                </template>
              </el-popover>
            </div>
          </el-menu-item>
          <el-menu-item index="7">
            <div class="strip"></div>
          </el-menu-item>
          <el-menu-item index="8">
          <div class="menuLable">
          <div class="iconSVG csvOutput ico_csv-output_up" @click="downloadArticleAsCsvFormat" tabindex="0">
          </div>
          <div class="csvFile" @click="downloadArticleAsCsvFormat">CSV出力</div>
           </div>
          </el-menu-item>
          <!-- 2020/12/11  Redmine #10120 -->
          <el-menu-item index="9" v-if="getSelectedTheme[0]?getSelectedTheme[0].value=='Theme':false">
           <div class="strip"></div>
          </el-menu-item>
          <!-- 2020/12/11  Redmine #10120 -->
          <el-menu-item index="10" v-if="getSelectedTheme[0]?getSelectedTheme[0].value=='Theme':false">
           <!-- 2021/10/11 #全記事一括CSV出力ボタンの挙動 -->
           <!-- <div class="menuLable"> -->
           <!--    <div class="iconSVG csvOutput ico_csv-output_up" @click="downloadThemeArticleAsCsvFormat" tabindex="2"></div> -->
           <!--    <div class="csvFile" @click="downloadThemeArticleAsCsvFormat">全記事一括CSV出力</div> -->
           <!--  </div> -->

            <el-tooltip class="item" effect="custom" placement="top-start" id="">
              <div class="display-size" slot="content">
                <span :class="{'tooltip-small':getDefault_Font_Size==0,'tooltip-medium':getDefault_Font_Size==1,'tooltip-large':getDefault_Font_Size===undefined}">当日分は午前7時30分過ぎにCSVへ反映されます</span>
              </div>
              <div class="menuLable">
                <div class="toolTipDiv">
                  <div class="iconSVG csvOutput ico_csv-output_up" @click="downloadThemeArticleAsCsvFormat" tabindex="2"></div>
                </div>
                <div class="csvFile" @click="downloadThemeArticleAsCsvFormat">全記事一括CSV出力</div>
              </div>
            </el-tooltip>
            <!-- 2021/10/11 #全記事一括CSV出力ボタンの挙動 -->
          </el-menu-item>
        </el-menu>
      </div>
      <el-col :span="24">
        <div class="accord">
          <div v-for="(set,index) in groups" v-bind:key="index">
            <div id="anim">
              <transition name="slide">
                <el-collapse-transition> 
                  <div class="colloapse_none">
                    <div v-for="(item,index) in set.items" v-bind:key="index">
                      <el-checkbox-group v-model="getWebCsvDetails" @change="handleCheckedArticlesChange">
                        <WebTabDraggable v-bind:articleList="getWebArticledetails" ref="webTabDraggableRef"/>
                      </el-checkbox-group>
                    </div>
                  </div>
                </el-collapse-transition>
              </transition>
            </div>
          </div>
        </div>
      </el-col>
    </el-row> 
  </div>
</template>
 
<!-- --SCRIPT--- -->
<script>
import { mapGetters } from "vuex";
import WebTabDraggable from "./WebTabDraggable.vue";
import $ from "jquery";
import json from "../../components/config.json";
 
export default {
 
  components: {
  WebTabDraggable
  },
  data() {
    return {
      fullscreenLoading: false,
      visible: false,
      groups: {
        "group 1": {
          name: "Menu 1",
          open: "false",
          items: ["item1"]
        }
      },
      drag: false,
      dropdownoptions4: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      dropdownoptions3: [
        {
          value: "なし",
          label: "なし"
        },
        {
          value: "昇順",
          label: "昇順"
        },
        {
          value: "降順",
          label: "降順"
        }
      ],
      optionValue4: "なし",
      optionValue3: "なし",
      select_date_value: '',
      select_title_value: '',
      scroll_sort_date: '',
      scroll_sort_title: '',
      startDateResult: '',
      endDateResult: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      checklistVal: [],
      checkAll: false,
      isActive: false,
      isMedActive: true,
      isBigActive: false,
      csv_download_flag: false,
      all_articles_selectable_flag: false,
      setCancelValue: true,
    };
  },
  methods: {
    cancelSort(){
      this.$LogButtonEvent("webTab","Cancell");
      this.$LogMethodIN("webTab","cancelSort");
      if(this.setCancelValue)
      {
        this.$store.commit('situation/setWebDateValue', 'なし');
        this.$store.commit('situation/setWebTitleValue', 'なし');
        this.select_date_value='';
        this.select_title_value='';
        this.$store.commit('situation/setSortWebDateText', false);
        this.$store.commit('situation/setSortWebTitleText', false);
        this.$store.commit('situation/setAscendingWebDateIcon', false);
        this.$store.commit('situation/setDecendingWebDateIcon', false);
        this.$store.commit('situation/setAscendingWebTitleIcon', false);
        this.$store.commit('situation/setDecendingWebTitleIcon', false);
      }
      else
      {
        if(this.getSelectedWebSortDate != '')
        {
          this.$store.commit('situation/setWebDateValue', this.getSelectedWebSortDate);
          this.$store.commit('situation/setWebTitleValue', 'なし');

        }
        else if(this.getSelectedWebSortTitle != '')
        {
          this.$store.commit('situation/setWebDateValue', 'なし');
          this.$store.commit('situation/setWebTitleValue', this.getSelectedWebSortTitle);
        }
      }
      this.visible = false
      this.$LogMethodOut("webTab","cancelSort");
    },
    //method for sorting the article based on article date and title
    articleSorting(){
      this.$LogButtonEvent("webtab","ArticleSorting");
      this.$LogMethodIN("webtab","articleSorting");
      //set the date and title sort values which is selected in Web Tab
      this.select_date_value = this.getWebDateValue;
      this.select_title_value = this.getWebTitleValue;

      // 2021/05/25  #11297  START  
      if(this.$store.getters['situation/getSortWebDateText'])
      {
        if((this.select_date_value == "昇順" && !this.$store.getters['situation/getAscendingWebDateIcon']) ||
        (this.select_date_value == "降順" && !this.$store.getters['situation/getDecendingWebDateIcon']) ||
        (this.select_date_value == "なし" || this.select_date_value == ''))
        {
          if(this.getWebCsvDetails.length != 0)
          {
            this.$store.commit("situation/setWebCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getWebCheckboxSelect'])
          {
            this.$store.commit('situation/setWebCheckboxSelect', false);
          }
        }
      }
      else if(this.$store.getters['situation/getSortWebTitleText'])
      {
        if((this.select_title_value == "昇順" && !this.$store.getters['situation/getAscendingWebTitleIcon']) ||
        (this.select_title_value == "降順" && !this.$store.getters['situation/getDecendingWebTitleIcon']) ||
        (this.select_title_value == "なし" || this.select_title_value == ''))
        {
          if(this.getWebCsvDetails.length != 0)
          {
            this.$store.commit("situation/setWebCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getWebCheckboxSelect'])
          {
            this.$store.commit('situation/setWebCheckboxSelect', false);
          }
        }
      }
      else if((this.select_title_value == "昇順" || this.select_title_value == '降順' ||
      this.select_date_value == "昇順" || this.select_date_value == "降順")
      && !this.$store.getters['situation/getSortWebDateText']
      && !this.$store.getters['situation/getSortWebTitleText'])
      {
        if(this.getWebCsvDetails.length != 0)
          {
            this.$store.commit("situation/setWebCsvDetails", []);
            // 2021/06/28  #11594  START
            this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
            // 2021/06/28  #11594  END
          }

          if(this.$store.getters['situation/getWebCheckboxSelect'])
          {
            this.$store.commit('situation/setWebCheckboxSelect', false);
          }
      }
      // 2021/05/25  #11297  END

      if(this.select_date_value != '' && this.select_date_value != 'なし')
      {
        this.$store.commit('situation/setSelectedWebSortDate', this.select_date_value);
        this.$store.commit('situation/setSelectedWebSortTitle', '');

        this.$store.commit('situation/setSortWebDateText', true);
        this.$store.commit('situation/setSortWebTitleText', false);
        if(this.select_date_value == "昇順")
        {
          this.scroll_sort_date = 'asc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingWebDateIcon', true);
          this.$store.commit('situation/setDecendingWebDateIcon', false);
        }
        else if(this.select_date_value == "降順")
        {
          this.scroll_sort_date = 'desc';
          this.scroll_sort_title = '';
          this.$store.commit('situation/setAscendingWebDateIcon', false);
          this.$store.commit('situation/setDecendingWebDateIcon', true);
        }
      }
      else if(this.select_title_value != '' && this.select_title_value != 'なし')
      {
        this.$store.commit('situation/setSelectedWebSortDate', '');
        this.$store.commit('situation/setSelectedWebSortTitle', this.select_title_value);

        this.$store.commit('situation/setSortWebDateText', false);
        this.$store.commit('situation/setSortWebTitleText', true);
        if(this.select_title_value == "昇順")
        {
          this.scroll_sort_title = 'asc';
          this.scroll_sort_date = '';
          // 2021/06/28  #11594  START
          this.$store.commit('situation/setAscendingWebTitleIcon', true);
          this.$store.commit('situation/setDecendingWebTitleIcon', false);
          // 2021/06/28  #11594  END
        }
        else if(this.select_title_value == "降順")
        {
          this.scroll_sort_title = 'desc';
          this.scroll_sort_date = '';
          this.$store.commit('situation/setAscendingWebTitleIcon', false);
          this.$store.commit('situation/setDecendingWebTitleIcon', true);
        }
      }
      else if((this.select_date_value == 'なし' || this.select_date_value == '') && (this.select_title_value == 'なし' || this.select_title_value == ''))
      {
        this.scroll_sort_title = '';
        this.scroll_sort_date = '';
        this.$store.commit('situation/setSelectedWebSortDate', 'なし');
        this.$store.commit('situation/setSelectedWebSortTitle', 'なし');
        this.$store.commit('situation/setSortWebDateText', false);
        this.$store.commit('situation/setSortWebTitleText', false);
      }
      this.setCancelValue = false;
      var themeValue = this.getSelectedTheme[0].value;
      var theme_id = this.getSelectedTheme[0].id;
      var webinputParam;
      
      if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if article is loaded based on theme values
      {
        if(themeValue == "Theme")//if selected theme value is theme
        {
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount,
            theme_id: theme_id
          }
        }
        else if(themeValue == "Theme Group")//if selected theme value is theme group
        {
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount,
            theme_group_id: theme_id
          }
        }
        else//if selected theme value is topics
        {
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.getDefaultThemeStartDate,
            process_date_end:this.getDefaultThemeEndDate,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount,
            topics_id: theme_id
          }
        }
        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article
        this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if article is loaded based on today's article values
      {
        webinputParam ={
          contract_id: this.contractId,
          data_section: 3,
          process_date_start:this.getDefaultThemeStartDate,
          process_date_end:this.getDefaultThemeEndDate,
          sort_date: this.scroll_sort_date,
          sort_title: this.scroll_sort_title,
          start_num:1,
          load_num:this.getWebTotalNewsCount
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article
        this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
        
      }
      else if(this.getSearchConditionKey == 1)
      {
        if(this.getSearchValue != '')//if value is selected from search dropdown
        {
          webinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 2,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            search_title: this.getSearchValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount
          }
        }
        else if(this.getKeywordValue != '')//if keyword textbox is not equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            webinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 2,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getWebTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            webinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 2,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              key_word: this.getKeywordValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getWebTotalNewsCount
            }
          }
        }
        else//if keyword textbox is equal to empty
        {
          if(this.getMediaValue != '')//if media texbox is not equal to empty
          {
            webinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 2,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              media_name: this.getMediaValue,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getWebTotalNewsCount
            }
          }
          else//if media texbox is equal to empty
          {
            webinputParam ={
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 2,
              display_id: 'SID0002',
              process_date_from:this.getSearchStartDate,
              process_date_to:this.getSearchEndDate,
              theme_browsing: this.theme_browsing,
              sort_date: this.scroll_sort_date,
              sort_title: this.scroll_sort_title,
              start_num:1,
              load_num:this.getWebTotalNewsCount
            }
          }
        }

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getWebArticleUsingSorting', webinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else if(this.getSearchConditionKey == 2)
      {
        if(this.getKeywordValue != '')
        {
          webinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 2,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            key_word: this.getKeywordValue,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount
          }
        }
        else
        {
          webinputParam ={
            contract_id: this.contractId,
            user_id: this.userId,
            contract_kbn: 2,
            display_id: 'SID0002',
            process_date_from:this.getSearchStartDate,
            process_date_to:this.getSearchEndDate,
            theme_browsing: this.theme_browsing,
            sort_date: this.scroll_sort_date,
            sort_title: this.scroll_sort_title,
            start_num:1,
            load_num:this.getWebTotalNewsCount
          }
        }
        

        //hide the sorting dialog box
        this.visible = false;
        this.fullscreenLoading = true;
        //Api call for sorting the news article(AID0071)
        this.$store.dispatch('communication/getWebArticleUsingSorting', webinputParam).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      else
      {
        //no action needed
      }
     this.$LogMethodOut("webtab","articleSorting"); 
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    //method for reset the date and title value for sorting the article
    clear (){
      this.$LogButtonEvent("webtab","Reset");
      this.$LogMethodIN("webtab","clear");
      this.$store.commit('situation/setWebDateValue', 'なし');
      this.$store.commit('situation/setWebTitleValue', 'なし');
      this.select_date_value= '';
      this.select_title_value= '';
      this.scroll_sort_date = '';
      this.scroll_sort_title = '';
      this.$LogMethodOut("webtab","clear");
    },
    //method for get the article no from selected article checkboxex
    handleCheckAllChange(val){
      this.$LogButtonEvent("webtab","SelectAll");
      this.$LogMethodIN("webtab","handleCheckAllChange");      
      if(val)
      {
        if(this.getWebArticledetails.length == this.getThemeWebCount)
        {
          this.checklistVal = val ? this.getArticlesIds() : [];        
          this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
          if(this.checklistVal.length > 0)
          {
            this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
            this.$store.commit('situation/setWebCheckboxSelect', true);
          }
          else
          {
            this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
            this.$store.commit('situation/setWebCheckboxSelect', false);
          }
        }
        else
        {
          var themeValue = this.getSelectedTheme[0].value;
          var theme_id = this.getSelectedTheme[0].id;
          var startNumCount = this.getWebArticledetails.length + 1;
          var loadNumCount = this.getThemeWebCount - this.getWebArticledetails.length;
          var webinputParam;
          
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
          {
            if(themeValue == "Theme")
            {
              webinputParam = {
                contract_id: this.contractId,
                data_section: 3,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_id: theme_id
              };
            }
            else if(themeValue == "Theme Group")
            {
              webinputParam = {
                contract_id: this.contractId,
                data_section: 3,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                theme_group_id: theme_id
              };
            }
            else
            {
              webinputParam = {
                contract_id: this.contractId,
                data_section: 3,
                process_date_start: this.getDefaultThemeStartDate,
                process_date_end: this.getDefaultThemeEndDate,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num: startNumCount,
                load_num: loadNumCount,
                topics_id: theme_id
              };
            }

            var existingArticleDetails = [];

            existingArticleDetails = [...existingArticleDetails, webinputParam, this.getWebArticledetails];

            this.fullscreenLoading = true;
            this.$store
              .dispatch("communication/getWebArticles", existingArticleDetails)
              .then(() => {
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];        
                this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', false);
                }
              }).catch(()=>{
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];        
                this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', false);
                }
              });
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)
          {
            
            webinputParam = {
              contract_id: this.contractId,
              data_section: 3,
              process_date_start: this.getDefaultThemeStartDate,
              process_date_end: this.getDefaultThemeEndDate,
              sort_date: this.getScrollingWebDate,
              sort_title: this.getScrollingWebTitle,
              start_num: startNumCount,
              load_num: loadNumCount
            };

            var existingTodayArticleDetails = [];

            existingTodayArticleDetails = [...existingTodayArticleDetails, webinputParam, this.getWebArticledetails];

            this.fullscreenLoading = true;
            this.$store.dispatch("communication/getWebArticles", existingTodayArticleDetails).then(() => {
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];        
              this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];        
              this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', false);
              }
            });
          }
          else if(this.getSearchConditionKey == 1)
          {
            if(this.getSearchValue != '')
            {
              webinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 2,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                search_title: this.getSearchValue,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else if(this.getKeywordValue != '')
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  key_word: this.getKeywordValue,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }
            else
            {
              if(this.getMediaValue != '')//if media texbox is not equal to empty
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  media_name: this.getMediaValue,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
              else
              {
                webinputParam ={
                  contract_id: this.contractId,
                  user_id: this.userId,
                  contract_kbn: 2,
                  display_id: 'SID0002',
                  process_date_from:this.getDefaultThemeStartDate,
                  process_date_to:this.getDefaultThemeEndDate,
                  theme_browsing: this.theme_browsing,
                  sort_date: this.getScrollingWebDate,
                  sort_title: this.getScrollingWebTitle,
                  start_num:startNumCount,
                  load_num:loadNumCount
                }
              }
            }

            var existingSearchArticle = [];

            existingSearchArticle = [...existingSearchArticle, webinputParam, this.getWebArticledetails];

            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getWebArticleUsingSorting', existingSearchArticle)
            .then(() => {
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];        
                this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', false);
                }
              }).catch(()=>{
                this.fullscreenLoading = false;
                this.checklistVal = val ? this.getArticlesIds() : [];        
                this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
                if(this.checklistVal.length > 0)
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', true);
                }
                else
                {
                  this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                  this.$store.commit('situation/setWebCheckboxSelect', false);
                }
              });
          }
          else if(this.getSearchConditionKey == 2)
          {
            if(this.getKeywordValue != '')
            {
              webinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 2,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                key_word: this.getKeywordValue,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            else
            {
              webinputParam ={
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 2,
                display_id: 'SID0002',
                process_date_from:this.getDefaultThemeStartDate,
                process_date_to:this.getDefaultThemeEndDate,
                theme_browsing: this.theme_browsing,
                sort_date: this.getScrollingWebDate,
                sort_title: this.getScrollingWebTitle,
                start_num:startNumCount,
                load_num:loadNumCount
              }
            }
            
            var existingSearchKeywordArticle = [];

            existingSearchKeywordArticle = [...existingSearchKeywordArticle, webinputParam, this.getWebArticledetails]
            this.fullscreenLoading = true;
            //Api call for sorting the news article(AID0071)
            this.$store.dispatch('communication/getWebArticleUsingSorting', existingSearchKeywordArticle)
            .then(() => {
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];        
              this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', false);
              }
            }).catch(()=>{
              this.fullscreenLoading = false;
              this.checklistVal = val ? this.getArticlesIds() : [];        
              this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
              if(this.checklistVal.length > 0)
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', true);
              }
              else
              {
                this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
                this.$store.commit('situation/setWebCheckboxSelect', false);
              }
            });
          }
          else
          {
            //no action needed
          }
        }
      }
      else
      {
        this.checklistVal = val ? this.getArticlesIds() : [];   
        this.$store.commit('situation/setWebCsvDetails', this.checklistVal);
        if(this.checklistVal.length > 0)
        {
          this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setWebCheckboxSelect', true);
        }
        else
        {
          this.$store.commit("situation/setWebFirstTabCheckboxValue", this.checklistVal.length);
          this.$store.commit('situation/setWebCheckboxSelect', false);
        }
        this.$LogMethodOut("webtab","handleCheckAllChange");
      }
    },
    handleCheckedArticlesChange(value){
      this.$LogButtonEvent("webtab","CheckArticle");
      this.$LogMethodIN("webtab","handleCheckedArticlesChange");      
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.getWebArticledetails.length;
      this.$store.commit('situation/setWebCheckboxSelect', this.checkAll);
      this.$LogMethodOut("webtab","handleCheckedArticlesChange");
    },
    //method for get the value from date dropdown
    selectDateValue($event){
      this.$LogButtonEvent("webtab","selectDate");
      this.$LogMethodIN("webtab","selectDateValue");      
      for(var j=0; j<this.dropdownoptions4.length;j++)
      {
          if($event == this.dropdownoptions4[j].value)
          {
            this.select_date_value = this.dropdownoptions4[j]["value"];
					}
      }
      if(this.select_date_value == "昇順")
      {
        this.scroll_sort_date = 'asc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setWebDateValue', '昇順');
        this.$store.commit('situation/setWebTitleValue', 'なし');
      }
      else if(this.select_date_value == "降順")
      {
        this.scroll_sort_date = 'desc';
        this.scroll_sort_title = '';
        this.select_title_value = '';
        this.$store.commit('situation/setWebDateValue', '降順');
        this.$store.commit('situation/setWebTitleValue', 'なし');
      }
      else
      {
        this.scroll_sort_date = '';
        this.$store.commit('situation/setWebDateValue', 'なし');
      }
      this.$store.commit("situation/setScrollingWebDate", this.scroll_sort_date);
      this.$LogMethodOut("webtab","selectDateValue");
    },
    //method for get the value from title dropdown
    selectTitleValue($event){
      this.$LogButtonEvent("webtab","selectTitle");
      this.$LogMethodIN("webtab","selectTitleValue");        
      for(var j=0; j<this.dropdownoptions3.length;j++)
      {
          if($event == this.dropdownoptions3[j].value)
          {
            this.select_title_value = this.dropdownoptions3[j]["value"];
					}
      }
      if(this.select_title_value == "昇順")
      {
        this.scroll_sort_title = 'asc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setWebDateValue', 'なし');
        this.$store.commit('situation/setWebTitleValue', '昇順');
      }
      else if(this.select_title_value == "降順")
      {
        this.scroll_sort_title = 'desc';
        this.scroll_sort_date = '';
        this.select_date_value = '';
        this.$store.commit('situation/setWebDateValue', 'なし');
        this.$store.commit('situation/setWebTitleValue', '降順');
      }
      else
      {
        this.scroll_sort_title = '';
        this.$store.commit('situation/setWebTitleValue', 'なし');
      }
      this.$store.commit('situation/setScrollingWebTitle', this.scroll_sort_title);
      this.$LogMethodOut("webtab","selectTitleValue");
    },
    //methods for setting the all article content size as small
    webTabDecrease() {
      this.$LogButtonEvent("webtab","CurrentNews");
      this.$LogMethodIN("webtab","webTabDecrease");       
      $('.AllWebInfiniteWrapper').css('max-height', '400px');      
      $('.AllWebTabInfiniteWrapper').css('max-height', '200px');
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      this.$LogMethodOut("webtab","webTabDecrease");
    },
    //methods for setting the all article content size as medium
    webTabReset() {
      this.$LogButtonEvent("webtab","CurrentNews");
      this.$LogMethodIN("webtab","webTabReset");      
      $('.AllWebTabInfiniteWrapper').css('max-height', '400px');
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      this.$LogMethodOut("webtab","webTabReset");
    },
    //methods for setting the all article content size as large
    webTabIncrease() {
      this.$LogButtonEvent("webtab","BigNews");
      this.$LogMethodIN("webtab","webTabIncrease");       
      $('.AllWebTabInfiniteWrapper').css('max-height', '700px');
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      this.$LogMethodOut("webtab","webTabIncrease");
    },
    downloadArticleAsCsvFormat(){
      this.$LogButtonEvent("webtab","DownloadCsvFormat");
      this.$LogMethodIN("webtab","downloadArticleAsCsvFormat");        
      var article_details = [];
      var WebArticle = this.getWebArticledetails;
      var csvDownloadValues;
      if(this.getWebCsvDetails.length != 0)
      {
        // for(var i=0;i<this.getWebCsvDetails.length;i++)
        // {
        //   for(var j=0;j<WebArticle.length;j++)
        //   {
        //     if(WebArticle[j].article_no == this.getWebCsvDetails[i])
        //     {
        //       article_details = [...article_details, {article_id: WebArticle[j].article_id, data_section: WebArticle[j].data_section}];
        //     }
        //   }
        // }
        //Modified for BT08460_EXTERNAL-1784
        for(var i=0;i<WebArticle.length;i++)
        {
          for(var j=0;j<this.getWebCsvDetails.length;j++)
          {
             if(WebArticle[i].article_no == this.getWebCsvDetails[j])
             {
               article_details.push({
                 article_id: WebArticle[i].article_id, 
                 data_section: WebArticle[i].data_section
                });
             }
          }
        }

        var themeValue = this.getSelectedTheme[0].value;
        var theme_id = this.getSelectedTheme[0].id;
        if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)
        {
          if(themeValue == "Theme")
          {
            csvDownloadValues = {
              theme_data_section:3,
              theme_name:theme_id,
              theme_group_name:null,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Theme Group")
          {
            csvDownloadValues = {
              theme_data_section:3,
              theme_name:null,
              theme_group_name:theme_id,
              topics_name:null,
              articles:article_details
            }
          }
          else if(themeValue == "Topics")
          {
            csvDownloadValues = {
              theme_data_section:3,
              theme_name:null,
              theme_group_name:null,
              topics_name:theme_id,
              articles:article_details
            }
          }
          else
          {
            //no action needed
          }
        }
        else
        {
          csvDownloadValues = {
            theme_data_section:3,
            theme_name:null,
            theme_group_name:null,
            topics_name:null,
            articles:article_details
          }
        }

        this.$store.dispatch('communication/downloadArticleDeliveryList', csvDownloadValues).then(() => {
          //After the Ajax call finished check if status is error for showing alert
          var status = this.getCsvDownloadErrStatus;
          var msgdetail = this.getCsvDownloadErrmsgDetail;
          if(status == "1")
          {
            this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
          }
          else
          {
           // console.log("else");
          }
        });
        
      }
      else
      {
        this.$confirm(
          json["1023_delete_confirm_message"],
          json["1023_delete_confirm_message_title"],
          {
            showCancelButton: false,
            confirmButtonText: "OK"
          }
        );
      }
      this.$LogMethodOut("webtab","downloadArticleAsCsvFormat");
    },
    downloadThemeArticleAsCsvFormat(){
      let downloadParam={
        theme_id: this.getSelectedTheme[0].id
      }
      this.fullscreenLoading = true;
      this.$store.dispatch('communication/downloadWebThemeArticleCsv', downloadParam).then(() => {
        this.fullscreenLoading = false;
          var status = this.getCsvDownloadErrStatus;
          var msgdetail = this.getCsvDownloadErrmsgDetail;
          if(status == "1")
          {
            this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
          }
        })
        .catch(()=>{
          this.fullscreenLoading = false;
        });
    },
    TapClickedInParent(){
      this.$refs.webTabDraggableRef[0].noMore();
    },
    getArticlesIds() {
      var articlesIds = [];
      this.getWebArticledetails.forEach(function(article){
        articlesIds.push(article.article_no);
      })
      return articlesIds;
    }
  },
  computed: {
    ...mapGetters("situation",["getWebArticles", 
                              "getWebArticledetails", 
                              "getSelectedTheme", 
                              "getWebTotalNewsCount",
                              "getDefaultDate",
                              "getSearchConditionKey",
                              "getSearchValue",
                              "getKeywordValue",
                              "getMediaValue",
                              "getSearchStartDate",
                              "getSearchEndDate",
                              "getWebSecondTabCheckboxValue",
                              "getWebSecondTabCsvDetails",
                              "getWebSecondTabCheckboxSelect",
                              "getCsvDownloadErrStatus",
                              "getCsvDownloadErrmsgDetail",
                              "getThemeWebCount",
                              "getWebRegisterFlag",
                              "getDefaultThemeStartDate",
                              "getDefaultThemeEndDate",
                              "getScrollingWebDate",
                              "getScrollingWebTitle",
                              "getTodayArticleFlag",
                              "getWebFirstTabCheckboxValue",
                              "getWebCheckboxSelect",
                              "getWebCsvDetails",
                              "getSelectedWebSortDate",
                              "getSelectedWebSortTitle",
                              "getAscendingWebDateIcon",
                              "getDecendingWebDateIcon",
                              "getAscendingWebTitleIcon",
                              "getDecendingWebTitleIcon",
                              "getSortWebDateText",
                              "getSortWebTitleText",
                              "getWebDateValue",
                              "getWebTitleValue"]),
    ...mapGetters("situation0001", ["getUserId",
                                  "getContractId",
                                  "getThemeBrowsing",
                                  "getServiceLinkageInfo",
                                  "getUserGroupLinkageInfo",
                                  "getDefault_Font_Size"]),
  },
  mounted(){

    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the service linkage info value from the session
    var service_linkage = this.getServiceLinkageInfo;

    for(var l=0;l<service_linkage.length;l++)
    {
      if(service_linkage[l].data_section == 3)
      {
        this.csv_download_flag = service_linkage[l].csv_output_flag;
      }
      else
      {
        //no action needed
      }
    }

    //get the user group linkage info value from the session
    var user_group_linkage = this.getUserGroupLinkageInfo;

    for(var k=0;k<user_group_linkage.length;k++)
    {
      if(user_group_linkage[k].data_section == 3)
      {
        this.all_articles_selectable_flag = user_group_linkage[k].all_articles_selectable_flag;
      }
      else
      {
        //no action needed
      }
    }
   
  },
  updated(){
    this.TapClickedInParent();
    var font_size_flag = this.getDefault_Font_Size;
    if(font_size_flag == 0)
    {
      $('.select_custom').css({"width": "64px"});
    }
    else if(font_size_flag == 1)
    {
      $('.select_custom').css({"width": "76px"});
    }
    else
    {
      $('.select_custom').css({"width": "108px"});
    }
  }
};
</script>
 
<!-- --STYLE--- -->
<style>
@import "../../assets/css/style.css";

.checkList .el-checkbox__inner {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  border: 2px solid #0097e0 !important;
  border-radius: 4px;
} 
.checkList.is-checked .el-checkbox__inner::after {
  height: 10px;
  left: 5.9px;
  top: 1px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  width: 5px;
}
.el-popover.el-popper .el-form .el-form-item .el-form-item__label {
  font-size: 9.6pt;
  padding-right: 8px !important;
      width: 48px;
}
.el-popover.el-popper .el-form .el-row {
  display: -webkit-box;
}
.el-input__suffix {
  right: 2px !important;
}
.el-input__inner {
  padding: 6px !important;
}
.el-icon-arrow-up:before {
  content: "\e6e1";
  font-size: 18px;
  text-shadow: 0px 0px 0.7px var(--grayDark);
}
.el-scrollbar
  > .el-select-dropdown__wrap.el-scrollbar__wrap
  > .el-select-dropdown__list {
  padding: 0px !important;
  background: var(--white) !important;
}
 
.el-scrollbar {
  overflow: hidden;
  position: relative;
  margin-top: -12px;
  width: 100% !important;
  box-shadow: 4px 3px 7px 0 rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--grayLight);
  border-radius: 4px;
  background: var(--white);
}
.el-select-dropdown {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.el-popover.el-popper[x-placement^="bottom"] {
    margin-top: 0px !important;
    margin-left: -11px !important;
    width: 271px !important;
}
.el-popover {
  padding: 0px 8px 8px 8px !important;
}

.el-button.el-button--default.el-popover__reference span {
  display: block;
   background: transparent;
}
 
#webTabFontSizeChange >>> .el-button {
  padding: 0px !important;
  margin: 0px !important;
}

/* element ui default classes end*/
/* -------------------------------------------------------------------------- */
/* custom css */
.dateSelect>.el-input.el-input--suffix.is-focus>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.dateSelect>.el-input.el-input--suffix>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.heading>.el-input.el-input--suffix.is-focus>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.heading>.el-input.el-input--suffix>.el-input__suffix>.el-input__suffix-inner {
  margin-right: 2px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect .el-input {
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect {
  width: 164px;
  margin-top: 16px;
}
.drop1 .el-select-dropdown__item.dateOption span {
  position: relative;
    display: block;
    top: 50%;
    transform: translateY(-50%);
}
.drop1 .el-select-dropdown__item.dateOption:first-child {
  margin-top: 3px;
}
.drop1 .el-select-dropdown__item.dateOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop2 .el-select-dropdown__item.headingOption span {
  position: relative;
    display: block;
    top: 50%;
    transform: translateY(-50%);
}
.drop2 .el-select-dropdown__item.headingOption:first-child {
  margin-top: 3px;
}
.drop2 .el-select-dropdown__item.headingOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop1 .el-select-dropdown__item.dateOption:hover{
    background-color: var(--selectHover) !important;
}
.drop2 .el-select-dropdown__item.headingOption:hover{
    background-color: var(--selectHover) !important;
}
.web-parent{
    margin-top: 0px;
}
.toolTipTop {
  width: 17px;
    position: absolute;
    left: 18px;
}
 .sortIconImage {
   margin-left: 1px
 }
.selectForm > .el-form-item.dateSelectLable > .el-form-item__label {
  margin-top: 15px;
  margin-left: 30px;
}
.selectForm > .el-form-item.headingLable > .el-form-item__label {
  margin-top: 7px;
  margin-left: 30px;
}

.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading {
  margin-top: 7px;
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading .el-input {
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
 
/* cancel button  */
.el-row.is-justify-space-between.el-row--flex .roundGrayDark {
  background: var(--white);
  color: var(--grayDark);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:hover {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:focus {
  background: var(--grayDark);
  color: var(--white);
  border: 1px solid var(--grayDark);
}
.el-row.is-justify-space-between.el-row--flex .el-row .roundGrayDark span {
  display: block;
  margin: 8px 11px 8px 11px;
}
 
/* reset button  */
.el-row.is-justify-space-between.el-row--flex .roundGray {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
  margin-top: 12px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundGray:hover {
  background: var(--white);
  border: 1px solid var(--grayDark2);
  color: var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGray:focus {
  background: var(--grayDark);
  border: 1px solid var(--grayDark);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundGray span {
  display: block;
  margin: 2px 11px 2px 11px;
}
/* Okay button  */
.el-row.is-justify-space-between.el-row--flex .roundBlue {
  background: var(--selectOption);
  color: var(--secondary);
  border: 1px solid var(--secondary);
  margin-left: 8px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:hover {
  background: var(--secondary);
  border: 1px solid var(--secondary);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:focus {
  background: var(--okayFocused);
  border: 1px solid var(--okayFocused);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue span {
  display: block;
  margin: 8px 24px 8px 24px;
}
 
 
.menu_grps {
  background-color: #bfaeab;
  font-size: 18px;
  display: inline;
}
#anim {
  overflow-y: hidden;
  width: 100%;
}

.accord {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.webTabRotate {
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.webTabRotate.down {
  -webkit-transition: all 0.2s;
    transition: all 0.2s;
    -webkit-transform: translate(-15%, -198%);
    transform: translate(-15%, -198%);
    position: absolute;
    margin: 8px 4px 4px 0px;
}
.selectList {
  height: 13pt;
}
.webTabArrowRotate {
  color: var(--secondary);
    font-size: 18px;
    float: right;
    top: 50%;
    position: relative;
    -webkit-transform: rotate(90deg) translate(-194%, 44%);
    transform: rotate(90deg) translate(-194%, 44%);
    margin: 8px 0px 4px 0px;
    font-weight: bold !important;
    position: absolute;
    right: 0;
    top: 38px;
}
.displaySizeLarge {
  display: inline-block;
  height: 100%;
  width: 100%;
}
.displaySizeLarge div span {
  display: block;
    position: relative;
    top: 50%;
        transform: translateY(-6px) translateX(18px);
}
.displaySizeLarge div {
  font-size: 8pt;
  float: left;
  height: 100%;
  position: relative;
  top: 50%;
  height: 15pt;
  transform: translate(19%, -50%);
  cursor: pointer;
}
.menuLable .selectList, .menuLable .printfile, .menuLable .fileDetail, .menuLable .csvFile, .menuLable .IconSort, .menuLable .selectAll {
  position: relative;
      top: 50%;
        transform: translateY(-50%);
    line-height: 20px;
    color: #000;
}
.menuLable div {
  font-size: 8pt;
  
}
.selectAll {
  margin-left: 4px;
  margin-top: 1px;
  height: 10pt !important;
}
.IconSort {
  margin-left: 4px !important;
  color: #000;
  margin-right: 0px !important;
}
.printfile,
.fileDetail,
.IconSort {
  margin-left: 30px;
  margin-right: 16px;
  height: 10pt !important;
}
.csvFile {
      margin-left: 26px;
  height: 10pt !important;
  margin-top: -1px;
}


.web-parent .rowSpan24 {
  border: 1px solid var(--primary);
  border-radius: 4px 4px!important;
  display: flex;
}
.webMenuParent2 {
  display: block;
  height: 100%;
}
.checkList {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  margin: auto 4px auto 8px !important;
}
.webNewsTitle  {
  margin: 0px 10px;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.menuLable {
  display: flex;
}
.menuLable label {
  padding-left: 0px !important
}

.webMenuTitle {
  font-size: 9.6pt;
  font-weight: bold;
  color: var(--white);
  background-color: var(--primary);
  min-width: 188px;
}
.sortIcon .el-button:hover {
  background: transparent;
}
.sortIcon .el-button {
  padding: 0px !important;
  background: transparent;
  margin-top: 0px;
}
.sortIcon .el-button span{
  border: none !important;
  background: transparent;
}

.webMenuParent {
  list-style: none;
  display: -webkit-inline-box;
  width: 100%;
  vertical-align: bottom;
}


.el-dropdown-link {
  cursor: pointer;
  margin-left: 5px;
}
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  list-style: none;
}

.list-group-item {
  cursor: move;
  font-size: 21px;
  background: #f4f4f4;
  margin: 10px 0px;
  padding: 10px;
  border: 1px solid #e4e4e4;
}

.list-group-item i {
  cursor: pointer;
}

/* Tooltip */
.display-size ul{
  list-style: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}

/* Alert model popup arrow style */
.el-popper[x-placement^=bottom] .popper__arrow:first-of-type {
  display: none !important;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  top: -18px !important;  
  margin-right: 3px !important;
  border-top-width: 0px !important;
  border-bottom-color: var(--grayLight) !important;
  display: block !important;
}
.el-popover.el-popper {
  margin-top: 24px !important;
  margin-left: -11px;
}
.el-select-dropdown.el-popper {
  margin-left: -10px;
  margin-top: 19px !important;
}

.el-tabs__item {
    background: var(--inActiveTab);
    margin-right: 1px;
    border-radius: 4px 4px 0px 0px;
    width: 188.86px !important;
}

/* Custom nave style */
.el-menu {
  width: 100%;
}

.el-menu--horizontal>.el-menu-item {
  height: 38px;
  padding: 0px;
  display: flex;
  border-bottom: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
}

.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow {
  left: 8px !important;
}
.sortIcon, .bigPopUp {
  display: flex;
}

.menuLable .csvFile:hover {
  opacity:0.6;
}

.menuLable .IconSort:hover {
  opacity:0.6;
}
.select_custom_box .el-checkbox__label {
  padding-left: 4px !important;
  margin-left: 0px !important;
}
/*  2021/11/23 #全記事一括CSV出力ボタンの挙動 START */
.tooltip-small {
  font-size: calc(7px * 2);
}
.tooltip-medium {
  font-size: calc(7.5px * 2);
}
.tooltip-large {
  font-size: calc(10px * 2);
}
/*  2021/11/23 #全記事一括CSV出力ボタンの挙動 END */
</style>
